import React, { Component, createRef } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppTheme } from '../../styles/AppTheme';
import { Bar, Line, Pie } from 'react-chartjs-2';
import Chart from 'react-chartjs-2';


export class ChartCard extends Component {
  constructor(props) {
    super(props);
    this.defaultErrMsg = 'An error occured.'
    this.state = {
      inProcess: false
    };
    this.chartOptions = {
              
                aspectRatio: window.innerWidth < 767 ? 1 : 2,
                responsive: true,
                //  maintainAspectRatio: false, 
                legend: {
                  display: true,
                },
                scales: {
                  xAxes: [{
                    stacked: false,
                    maxBarThickness: 40,
                    position: 'left',
                  }],
                  yAxes: [{
                    stacked: false,
                    ticks: {
                      beginAtZero: true,
                      stepSize: 5,
                    },
                  }]
                },          
              
            }
  }

  shouldComponentUpdate(nextProps, nextState) {
  // Only update if props that affect the chart actually changed
  return (
    nextProps.type !== this.props.type ||
    nextProps.item !== this.props.item ||
    nextProps.show !== this.props.show ||
    nextProps.chartType !== this.props.chartType
  );
}

  render() {
    return (
      <Grid item xs={12} sm={12}  className={css(Styles.container)}>
        {this.props.show && <Grid item xs={12} sm={12}>
          {this.props.show && <div className={css(Styles.paperTitle)} elevation={0}>
            <p className={css(Styles.paragraphMargin)}>{this.props.item.title}</p>
          </div>}
          <div>
            {this.state.inProcess &&
              <div className={css(Styles.loader)}>
                <CircularProgress size={48} className={css(Styles.progress)} />
              </div>
            }
          </div>
          <Chart
            type={this.props.type}
            data={this.props.item}
            redraw={true} 
            options={this.chartOptions}
            //  height={400}
          />

        </Grid>}
      </Grid>
    );
  }
};

const Styles = StyleSheet.create({
  container: {
    color: '#474747',
    backgroundColour: 'red',
  },
  paperFooter: {
    marginBottom: 0,
    display: 'flex',
    verticalAlign: 'top',
    justifyContent: 'flex-end'
  },
  paperTitle: {
    fontWeight: 'bold',
    // color: AppTheme.white,
    opacity: 0.8,
    marginBottom: 15,
    display: 'flex',
    alignItems: 'center'
  },
  subText: {
    display: 'inline-block',
    fontSize: 24,
    fontWeight: 'bold',
    flex: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'default',
    '@media(max-width: 768px)': {
      fontSize: 12
    }
  },
  arrowUp: {
    color: 'green'
  },
  arrowDown: {
    color: 'red'
  },
  videoContainerTile: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paragraphMargin: {
    margin: 0,
    flex: 1,
    cursor: 'default',
    '@media(max-width: 767px)': {
      fontSize: 14
    }
  },
  progress: {
    color: AppTheme.white
  },
  loader: {
    height: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});
